import React, { useMemo } from "react";
import ApplicationList from "../../components/applications/ApplicationList/ApplicationList";
import { useAuth } from "../../context/AuthContext";
import CardHeader from "../../components/common/CardHeader";

function Applications() {
  const { checkPermission } = useAuth();

  const appMode = useMemo(
    () =>
      checkPermission("Zmiana przypisania sprawy")
        ? "coordinator"
        : checkPermission("Obsługa wniosków")
          ? "operator"
          : checkPermission("Obsługa wysyłki")
            ? "shipping"
            : "user",
    [checkPermission],
  );

  return (
    <>
      <CardHeader
        text={
          "Moje wnioski " +
          (checkPermission("Zmiana przypisania sprawy")
            ? "(Koordynator)"
            : checkPermission("Obsługa wniosków")
              ? "(Operator)"
              : "")
        }
        onlyText="true"
      />
      <ApplicationList
        mode={appMode}
        paymentMode={false}
        shippingMode={false}
      />
    </>
  );
}

export default Applications;
